// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  color: 'accent',
  title: 'Farm Manager Developer Edition',
  title_xs: 'FM Dev',
  host: 'farm-manager-proto.an.r.appspot.com',
  origin: 'farm-manager-proto.firebaseapp.com',
  firebaseConfig:  {
    apiKey: "AIzaSyA58gTsY8CqWxtlXJosOAA90sEtQfAD1Bg",
    authDomain: "farm-manager-proto.firebaseapp.com",
    projectId: "farm-manager-proto",
    storageBucket: "farm-manager-proto.appspot.com",
    messagingSenderId: "925708118794",
    appId: "1:925708118794:web:43b63de79effe195a7a8f3"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
